<template>
    <div class="page-unmatched-quality">
        <div class="jumbo-wrapper unmatched-quality">
            <div class="jumbo-main">
                <div class="jumbo-content">
                    <p class="t15">UNMATCHED QUALITY</p>
                    <h2 class="t42">
                        HAND-CRAFTED
                        <br/>
                        ENGRAVED MESSAGES
                    </h2>
                    <p class="t20">Proven legibility that lasts.</p>
                </div>
            </div>
        </div>
        <div class="box-content">
            <div class="box-content-inner">
                <div class="container-inner-sm">
                    <div class="row checkbox-list">
                        <div class="col-sm-6 col-xs-12 col-md-4 text-center">
                            <div class="icon-box">
                                <img class="" src="images/checkbox.png" alt="">
                            </div>
                            <p class="bold">Laboratory tested under extreme freeze/thaw conditions and long-term sun exposure</p>
                        </div>
                        <div class="col-sm-6 col-xs-12 col-md-4 text-center">
                            <div class="icon-box">
                                <img class="" src="images/checkbox.png" alt="">
                            </div>
                            <p class="bold">Filler compliments material and maximizes legibility of messages</p>
                        </div>
                        <div class="col-sm-6 col-xs-12 col-md-4 text-center">
                            <div class="icon-box">
                                <img class="" src="images/checkbox.png" alt="">
                            </div>
                            <p class="bold">Featured at facilities large and small across the United States, Canada, and Mexico</p>
                        </div>
                    </div>

                    <hr class="frl-hr"/>

                    <div class="our-process">
                        <div class="our-process-left">
                            <img width="450" height="350" class="img-responsive" src="images/Unmatched-Quality/qualityengraving01.png" alt="Our Process">
                        </div>
                        <div class="our-process-right">
                            <h2>OUR PROCESS</h2>
                            <p class="basic-paragraph">
                                1. We start with a blank brick or tile, selected
                                for its strength and durability.
                            </p>
                            <p class="basic-paragraph">
                                2. Each letter is then sandblasted an 1/8” to
                                1/4” in depth by hand at our facility.
                            </p>
                            <p class="basic-paragraph">
                                3. After sandblasting the inscription, our
                                proprietary filler is inserted, making the letters
                                flush with the surface of the brick.
                            </p>
                            <p>
                                <router-link to="/product-guide" tag="button" class="learn-more-button">
                                    <span>REVIEW OUR PRODUCT GUIDE</span>
                                </router-link>
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="our-quality">
            <div class="our-quality-left">
                <img src="images/Unmatched-Quality/qualityengravingchevron.jpg" alt="">
            </div>
            <div class="our-quality-right">
                <p class="basic-paragraph">
                    Our unmatched quality combined with our hand-crafted process
                    and proprietary filler have been designed to preserve legibility
                    long after your fundraiser is complete. This method is the best at
                    preventing the collection of dirt and debris within the inscription
                    and has proven a game-changer within the industry.
                </p>
            </div>
        </div>

        <div class="box-content">
            <div class="box-content-inner">
                <!-- end of container sm -->
                <div class="testimonials testimonials-unmatched-quality">TESTIMONIALS</div>
                <testimonials-carousel>
                    <div class="carousel-inner quote-slider" role="listbox">
                        <div class="quote-slider-item item active">
                            <p class="slider-text">
                                "The bricks have withstood the Cincinnati weather changes and our customers remained pleased. It really adds a creative value to the entrance of our ballpark."
                            </p>
                            <div class="quote-author">
                                <span>Zach Bonkowski, Manager, Promotional Events</span>
                                <span> Cincinnati Reds</span>
                                <span>Phase I: 2002 | Phase II: 2004 | Phase III: 2013 | Phase IV: 2015 | Phase V: 2017 | Phase VI: 2019</span>
                            </div>
                        </div>
                        <div class="quote-slider-item item">
                            <p class="slider-text">
                                “The light filler color was a good choice for excellent legibility with minimal maintenance, even after four years in our high traffic areas and our extreme weather conditions.”
                            </p>
                            <div class="quote-author">
                                <span>Missy Tobey, Manager, Event Services</span>
                                <span>St. Louis Cardinals</span>
                            </div>
                        </div>
                        <div class="quote-slider-item item">
                            <p class="slider-text">
                                “In addition to the weather variations of Colorado to which they are exposed, they are located in an area of high pedestrian traffic. Through all of this, the bricks are as legible now as they were when they were installed.”
                            </p>
                            <div class="quote-author">
                                <span>Dave Moore, Director, Coors Field Administration &amp; Development</span>
                                <span>Colorado Rockies</span>
                            </div>
                        </div>
                    </div>
                </testimonials-carousel>
            </div>
        </div>
    </div>
</template>

<script type="text/jsx">
    import Testimonials from "./Testimonials";
    export default {
        name: 'engraving-method',
        components: {
            'testimonials-carousel': Testimonials
        },
        metaInfo: {
            title: 'Quality Engraving',
            meta: [
                {
                    vmid: 'description',
                    name: 'description',
                    content: 'For engraving method we use handmade production process and proprietary filler. It allows engraving on most clay and natural stone materials with excellent quality.'
                }
            ]
        }
    }
</script>



// WEBPACK FOOTER //
// UnmatchedQuality.vue?78af80bc